import PropTypes from 'prop-types';
import { isEmpty, uniqueId } from 'lodash';
import Icon from '../../Icon/Icon';
import AllOrOne from '../../AllOrOne/AllOrOne';
import EmailAddress from '../../Contact/EmailAddress/EmailAddress';
import HoursOfOperation from '../../HoursOfOperation/HoursOfOperation';
import addresses from '../../../utils/Addresses/';
import phones from '../../../utils/Phones';

const Location = (props) => {
  const {
    addressCount = null,
    className = '',
    clickableAddress = false,
    disableEmailLink = false,
    disablePhoneLink = false,
    hideLabels = false,
    isInNetworkGroup = true,
    originLatLng = [],
    showHours = true,
    showHoursIcon = false,
    showMore = false,
    stopEventPropagation = false,
    additionalContentComponent = null,
    intlProvider = {},
  } = props;
  const location = addresses.calculateDistance(props.location, originLatLng);
  const locationAddress = loc => (!isEmpty(originLatLng) ? `${loc.displayName} (${loc.distance})` : `${loc.displayName}`);

  const locationAddressWithLink = () => (clickableAddress ?
    <a
      href={addresses.makeGoogleMapLink(location)}
      rel="noopener noreferrer"
      target="_blank"
      className="locations-address-link"
    >
      {locationAddress(location)}
    </a> :
    locationAddress(location));

  const formattedPhoneNumber = phoneNumber => (
    (!hideLabels && phoneNumber.phone_type) ?
      `${phoneNumber.phone_type}: ${phones.formatPhoneNumber(phoneNumber.phone_number)}` :
      phones.formatPhoneNumber(phoneNumber.phone_number));

  const AdditionalContentComponent = additionalContentComponent;

  return (
    
    <div
      className={`location ${className}`}
      onClick={(e) => { if (stopEventPropagation) { e.stopPropagation(); } }}
    >
      <div
        className="location-address items-start flex"
        key={uniqueId(location.name || location.displayName)}
      >
        <Icon
          className="location-icon mr-2 flex-1.5"
          color={`${isInNetworkGroup ? 'action-blue' : 'brand-blue'}`}
          icon="MapPin"
          size={18}
        />
        <div className="location-content leading-6 pl-1 text-sm text-text-blue">

          { !hideLabels && location.name ?
            location.name :
            <p className="location-address-name flex flex-wrap capitalize">
              <span className="mr-2">{locationAddressWithLink(location)}</span>
              <span className="location-address-name-more text-action-blue">
                {!isEmpty(addressCount) ? addressCount : ''}
              </span>
            </p>
          }

          { !hideLabels && location.name && (
            <p className="location-address items-start flex">
              <span className="mr-2">{locationAddressWithLink(location)}</span>
              <span className="location-address-name-more text-action-blue">
                {!isEmpty(addressCount) ? addressCount : ''}
              </span>
            </p>
          )}

          <AllOrOne showAll={showMore}>
            { !isEmpty(location.phone_numbers) && location.phone_numbers.map(phoneNumber => (
              <p
                key={`phone-${phoneNumber.phone_number}`}
                className="location-phone capitalize"
              >
                { disablePhoneLink ?
                  formattedPhoneNumber(phoneNumber) :
                  <a
                    href={phones.getTelLink(phoneNumber)}
                    target="_blank"
                    tabIndex={0}
                    rel="noopener noreferrer"
                    className="text-action-blue"
                  >
                    { formattedPhoneNumber(phoneNumber) }
                  </a>
                }
              </p>
            ))
            }
          </AllOrOne>

          <AllOrOne showAll={showMore}>
            {
              !isEmpty(location.email_addresses) && location.email_addresses.map(email => (
                <p
                  className="location-email"
                  key={`email-${email}`}
                >
                  <EmailAddress
                    className="program-details-email-text"
                    disableLink={disableEmailLink}
                    emailAddress={email}
                  />
                </p>
              ))
            }
          </AllOrOne>
        </div>
      </div>
      { showHours &&
        <div className="location-hours pl-1">
          <HoursOfOperation
            hours={location.hours || location.hours_of_operation}
            isInNetworkGroup={isInNetworkGroup}
            showAll={showMore}
            showHoursIcon={showHoursIcon}
            showToggle
            intlProvider={intlProvider}
          />
        </div>
      }
      {additionalContentComponent && <AdditionalContentComponent location={location} />}
    </div>
  );
};

Location.propTypes = {
  addressCount: PropTypes.string,
  className: PropTypes.string,
  clickableAddress: PropTypes.bool,
  disableEmailLink: PropTypes.bool,
  disablePhoneLink: PropTypes.bool,
  hideLabels: PropTypes.bool,
  isInNetworkGroup: PropTypes.bool,
  location: PropTypes.object.isRequired,
  originLatLng: PropTypes.array,
  showHours: PropTypes.bool,
  showHoursIcon: PropTypes.bool,
  showMore: PropTypes.bool,
  stopEventPropagation: PropTypes.bool,
  /**
   * Property to pass a component that will render in the main content area of the component.
   * This feature is used to render an edit location link.
   */
  additionalContentComponent: PropTypes.func,
  intlProvider: PropTypes.object,
};


export default Location;
